<template>
  <v-chart :options="options" @contextmenu="contextmenu" />
</template>

<script>
import { DEFAULT_COLORS } from '../../../../constants';
import chartable from '../../../../mixins/chartable';

export default {
  mixins: [chartable],
  props: {
    barColor: {
      type: String,
      default: DEFAULT_COLORS[2],
    },
    backgroundColor: {
      type: String,
      default: DEFAULT_COLORS[9],
    },
    max: {
      type: Number,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
    animation: {
      type: Boolean,
      default: false,
    },
    areaStyle: {
      type: String,
      default: 'normal',
    },
    contextmenu: {
      type: Function,
      default: e => e,
    },
  },
  computed: {
    options() {
      return {
        animation: this.animation,
        color: [this.barColor],
        grid: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          transitionDuration: 0,
          axisPointer: {
            type: 'shadow',
          },
          formatter: parameter => {
            return `${parameter[0].value} / ${this.max}`;
          },
          textStyle: {
            fontSize: 12,
          },
        },
        xAxis: {
          type: 'value',
          show: false,
          max: this.max,
          axisLabel: {
            show: false,
          },
        },
        yAxis: {
          type: 'category',
          show: false,
          axisLabel: {
            show: false,
          },
          data: ['data'],
        },
        graphic: [
          {
            type: 'text',
            left: 'center',
            top: 'center',
            z: 100,
            style: {
              text: this.text,
            },
          },
        ],
        series: this.series,
      };
    },
    text() {
      return `${this.value} / ${this.max}`;
    },
    series() {
      return [
        {
          type: 'bar',
          barMaxWidth: '100%',
          showBackground: true,
          backgroundStyle: {
            color: this.backgroundColor,
          },
          itemStyle: this.itemStyle,
          label: {
            show: false,
          },
          data: [this.value],
        },
      ];
    },
    itemStyle() {
      let style = {};
      if (this.areaStyle == 'gradation') {
        style = this.areaStyleGradation(this.barColor);
      } else if (this.areaStyle == 'linearGradient') {
        style = this.areaStyleLinearGradient(this.barColor, 20, 30);
      } else if (this.areaStyle == 'spinLinearGradient') {
        style = this.areaStyleSpinLinearGradient(this.barColor, 20, 30);
      }
      return style;
    },
  },
};
</script>
